import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Checkbox, FormControl, InputLabel } from "@mui/material";
import { TextField, Typography } from "@mui/material";
import { Box, Button, IconButton } from "@mui/material";
import { Form } from "formik";
import { styles, useStyles } from "../../pages/MyTracks/styles";
import { EmailInviteTextField } from "../../pages/MyTracks/styles";
import { LightTooltip } from "../LightToolTip/LightToolTip";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Files from "react-files";
import { batchTrackAddModalStyles } from "../Modal/styles";
import { addTrackFileModalStyles } from "../Modal/styles";
import { APP_BACKGROUND_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";
import { UsernameSelectField } from "../../pages/MyTracks/styles";
import { TrackFilesUploadFormProps } from "./types";
import { SelectField } from "../../pages/ProfileSettings/types";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const TrackFilesUploadForm: React.FC<TrackFilesUploadFormProps> = ({
  isSubmitting,
  handleRemoveEmail,
  emailInviteList,
  handleCollabInvites,
  emailInvite,
  setEmailInvite,
  removeCollaborator,
  collaborators,
  collabVal,
  addCollaborator,
  usersList,
  setCollabVal,
  showCollabTooltip,
  setShowCollabTooltip,
  fileLabel,
  setFileLabel,
  handleShowCollabTooltip,
  errors,
  showTrackVersionTooltip,
  setShowTrackVersionTooltip,
  handleShowVersionTooltip,
  handleFileRemove,
  setFieldValue,
  files,
  handleAddFileToUpload,
  track,
  allTracksList,
  selectedTracksList,
  handleChangeTracksList,
}) => {
  const classes = useStyles();

  return (
    <>
      <Form>
        <Box style={{ color: TEXT_COLOR }} className="form-content">
          <label
            style={{ color: errors.fileUpload ? "red" : TEXT_COLOR }}
            className="uploadLabel"
          >
            Upload Files
            <span className="asterisk">*</span>
          </label>
          <Files
            className="image-upload"
            style={{
              ...styles.file,
              ...{ borderColor: errors.fileUpload ? "red" : TEXT_COLOR },
            }}
            onChange={(newFiles: any[]) => handleAddFileToUpload(newFiles)}
            multiple={true}
            minFileSize={0}
            clickable
          >
            <FileUploadIcon
              sx={{ width: "25px", height: "25px", marginRight: 2 }}
            />
            Drop a file here or click to upload
          </Files>
          {files.map((file) => (
            <Box key={file.id} sx={batchTrackAddModalStyles.fileMainContainer}>
              <Box sx={{ display: "flex", width: "100%" }}>
                <Box sx={styles.extensionContainer}>{file.extension}</Box>
                <Box sx={batchTrackAddModalStyles.fileNameContainer}>
                  <Box sx={{ width: "80%" }}>{file.name}</Box>
                  <Box>{file.sizeReadable}</Box>
                </Box>
              </Box>
              <IconButton
                sx={{ marginLeft: "10px" }}
                onClick={() => {
                  handleFileRemove(file.id);
                  if (files.length === 1) {
                    setFieldValue("hasSong", false);
                  }
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          ))}
          <p className="input-description"></p>
          <Box className="input">
            <label style={{ color: TEXT_COLOR }} htmlFor="label">
              File Label <span className="optional-input">(optional)</span>
              <Box
                style={{ display: "inline" }}
                onMouseOver={() => setShowTrackVersionTooltip(true)}
                onMouseLeave={() => setShowTrackVersionTooltip(false)}
              >
                <LightTooltip
                  title="File label uniquely identifies this uploaded file of your track"
                  placement="top"
                  open={showTrackVersionTooltip}
                  onClick={handleShowVersionTooltip}
                >
                  <IconButton disableRipple>
                    <HelpOutlineIcon
                      color="info"
                      style={{ height: 16, width: 16 }}
                    />
                  </IconButton>
                </LightTooltip>
              </Box>
            </label>
            <input
              style={styles.fileLabel}
              type="text"
              name="label"
              id="label"
              placeholder="Add a label for this file for the track"
              value={fileLabel}
              onChange={(event) => {
                // setFieldValue("fileLabel", event.target.value);
                setFileLabel(event.target.value);
              }}
              disabled={isSubmitting}
            />
          </Box>
          {!track && (
            <Box sx={{ marginBottom: "10px" }}>
              <Typography>
                Link Track
                <LightTooltip title="Link file with Track" placement="top">
                  <IconButton disableRipple>
                    <HelpOutlineIcon
                      color="info"
                      style={{ height: 16, width: 16 }}
                    />
                  </IconButton>
                </LightTooltip>
              </Typography>
              <FormControl fullWidth sx={{ borderColor: "white" }}>
                <InputLabel sx={{ fontFamily: "Argumentum" }}>
                  {selectedTracksList.length > 0 ? "" : "Tracks"}
                </InputLabel>
                <SelectField
                  multiple
                  fullWidth
                  options={allTracksList.map((track) => track.getTitle())}
                  disableCloseOnSelect
                  value={selectedTracksList}
                  onChange={handleChangeTracksList}
                  renderOption={(props, option, { selected }) => (
                    <li {...props} style={{ fontFamily: "Argumentum" }}>
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      style={{ width: "100%" }}
                      {...params}
                      label={""}
                      InputLabelProps={{ shrink: false }}
                      classes={{ root: classes.customTextField }}
                    />
                  )}
                />
              </FormControl>
            </Box>
          )}
          {/* Collabs */}
          <Box className="collab-label">
            <span>Add Collaborators </span>
            <span className="optional-input">(optional)</span>
            <Box
              style={{ display: "inline" }}
              onMouseOver={() => setShowCollabTooltip(true)}
              onMouseLeave={() => setShowCollabTooltip(false)}
            >
              <LightTooltip
                title="You can add artists, composers, and more collaborators"
                placement="top"
                open={showCollabTooltip}
                onClick={handleShowCollabTooltip}
              >
                <IconButton disableRipple>
                  <HelpOutlineIcon
                    color="info"
                    style={{ height: 16, width: 16 }}
                  />
                </IconButton>
              </LightTooltip>
            </Box>
          </Box>
          <hr />

          <Box sx={addTrackFileModalStyles.collaboratorContainer}>
            <Box sx={{ width: "80%" }}>
              <label
                htmlFor="newCollaboratorUser"
                style={styles.modalCreatorUsername}
              >
                {"Creator's Username"}
              </label>
              <UsernameSelectField
                freeSolo
                forcePopupIcon={false}
                isOptionEqualToValue={(option, value) => option === value}
                inputValue={collabVal}
                onInputChange={(
                  event: React.SyntheticEvent<Element, Event>,
                  value: string
                ) => {
                  setCollabVal(value);
                }}
                options={usersList.map((item) => item.getUsername()).sort()}
                renderInput={(params) => (
                  <TextField
                    style={{
                      backgroundColor: APP_BACKGROUND_COLOR,
                      color: TEXT_COLOR,
                    }}
                    {...params}
                    label=" "
                    InputLabelProps={{ shrink: false }}
                    classes={{ root: classes.customTextField }}
                  />
                )}
                renderOption={(props, option: any) => (
                  <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                    {option}
                  </li>
                )}
              />
            </Box>
            <Button
              disabled={collabVal === ""}
              sx={addTrackFileModalStyles.collaboratorAddButton}
              size="small"
              variant="contained"
              onClick={() => {
                if (!isSubmitting) {
                  addCollaborator(collabVal);
                }
              }}
            >
              Add
            </Button>
          </Box>
          <Box className="collaborators" style={{ margin: "20px 0 40px" }}>
            <Box className="collaborators-target">
              {collaborators &&
                collaborators.length > 0 &&
                collaborators.map((collaborator, index) => (
                  <Box className="collaborator" key={index}>
                    <p style={{ fontFamily: FONT_FAMILY, flexGrow: 1 }}>
                      {collaborator.getUsername()}
                    </p>
                    {!isSubmitting && (
                      <IconButton
                        onClick={() => removeCollaborator(collaborator)}
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    )}
                  </Box>
                ))}
            </Box>
          </Box>

          <div style={addTrackFileModalStyles.horizontalDiv} />
          <Box sx={addTrackFileModalStyles.emailInviteContainer}>
            <Box sx={{ width: "80%" }}>
              <label htmlFor="emailInvite" style={styles.modalCreatorUsername}>
                {"Invite Collaborator"}
              </label>
              <EmailInviteTextField
                hiddenLabel
                variant="outlined"
                classes={{ root: classes.customTextField }}
                placeholder="Send an invite email to a collaborator"
                value={emailInvite}
                onChange={(
                  event: React.ChangeEvent<
                    HTMLTextAreaElement | HTMLInputElement
                  >
                ) => setEmailInvite(event.target.value)}
              />
            </Box>
            <Button
              disabled={emailInvite === ""}
              sx={addTrackFileModalStyles.emailInviteAddButton}
              size="small"
              variant="contained"
              onClick={handleCollabInvites}
            >
              Add
            </Button>
          </Box>

          <Box style={{ marginBottom: 10, width: "100%" }}>
            <Box>
              {emailInviteList &&
                emailInviteList.length > 0 &&
                emailInviteList.map((email, index) => (
                  <Box
                    className="collaborator"
                    style={{ width: "100%" }}
                    key={index}
                  >
                    <p style={{ fontFamily: FONT_FAMILY, flexGrow: 1 }}>
                      {email}
                    </p>

                    <IconButton onClick={() => handleRemoveEmail(email)}>
                      <DeleteForeverIcon />
                    </IconButton>
                  </Box>
                ))}
            </Box>
          </Box>

          <hr />

          <Button
            disabled={isSubmitting}
            fullWidth
            type="submit"
            sx={styles.modalSubmitButton}
            size="small"
            variant="contained"
          >
            <Typography variant="h1" sx={styles.modalSubmitButtonText}>
              {"Add Track Files"}
            </Typography>
          </Button>
        </Box>
      </Form>
    </>
  );
};
